<template>
  <div class="flex-grid">
    <div class="col2">
      <div class="main_heading">
        <h3>Create Fascia</h3>
        <a
          class="button_create"
          href="/fasciasList/"
        >Manage Fascias</a>
      </div>
      <div class="form-fields">
        <label for="roleName">
          <b>Select Fascia Group</b>
        </label>
        <select v-model="fasciaGroup">
          <option value>
            Select Option
          </option>
          <option
            v-for="(fasciagroup, key) in fasciaGroupsList"
            :key="key"
            :value="fasciagroup._id"
          >
            {{ fasciagroup.group_name }}
          </option>
        </select>
      </div>
      <div class="form-fields">
        <label for="fasciaName">
          <b>Fascia Name</b>
        </label>
        <input
          v-model="fasciaName"
          type="text"
          placeholder="Enter Fascia Name"
          name="fasciaName"
          required
        >
      </div>
      <!-- <div class="form-fields">
    <label for="fasciaName"><b>Fascia Logo</b></label>
    <input type="file"  name="fasciaGrou Logo"
     @change="onFileChange">
      </div>-->
      <a
        class="button_create"
        @click="createfascia()"
      >{{ action }}</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FasciaGroups',
  data() {
    return {
      isUpdate: false,
      action: 'Create',
      fasciaGroupsList: [],
      fasciaName: '',
      fasciaLogo: '',
      fasciaGroup: '',
    };
  },
  mounted() {
    const getfasciaGroups = fetch('/api/fasciaGroups/all', {
      credentials: 'same-origin',
    });
    getfasciaGroups
      .then(data => data.json())
      .then((data) => {
        this.fasciaGroupsList = data;
      });
    if (this.$route.query.id) {
      this.isUpdate = true;
      this.action = 'Update';
      const getfascia = fetch(`/api/fascias/${this.$route.query.id}`, {
        credentials: 'same-origin',
      });
      getfascia
        .then(data => data.json())
        .then((data) => {
          this.fasciaName = data.fasica_name;
          this.fasciaLogo = data.fascia_logo;
          this.fasciaGroup = data.fascia_group_id;
        });
    }
  },
  methods: {
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.fasciaLogo = files[0].name;
    },
    createfascia() {
      if (this.fasciaGroup === '') {
        this.$toasted.error('Please Select Fascia Group', { duration: 3000 });
        return true;
      }
      if (this.fasciaName === '') {
        this.$toasted.error('Please Enter Fascia Name', { duration: 3000 });
        return true;
      }
      let url = '/api/createfascia';
      const data = {
        fasciaGroup: this.fasciaGroup,
        fasciaName: this.fasciaName,
        fasciaLogo: this.fasciaLogo,
      };
      let currentMethod = 'POST';
      if (this.isUpdate) {
        currentMethod = 'PUT';
        url = `/api/createfascia/${this.$route.query.id}`;
      }
      fetch(url, {
        method: currentMethod, // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .then(response => this.$toasted.success(response.message, { duration: 3000 }))
        .then(
          setTimeout(() => this.$router.push({ name: 'fasciasList' }), 3000),
        )
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ));
      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex-grid {
  display: flex;
  justify-content: space-between;
}

.col2 {
  width: 100%;
}

.success-msg {
  color: green;
  display: block;
  padding: 3px;
}
</style>
